const regionsAndCountries = [
  {
    regionName: 'Africa',
    countries: [
      {
        cca2: 'DZ',
        name: 'Algeria',
        url: 'photobookalgeria.com',
      },
      {
        cca2: 'AO',
        name: 'Angola',
        url: 'photobookangola.com',
      },
      {
        cca2: 'CM',
        name: 'Cameroon',
        url: 'photobookcameroon.com',
      },
      {
        cca2: 'CD',
        name: 'Congo',
        url: 'photobookcongo.com',
      },
      {
        cca2: 'KE',
        name: 'Kenya',
        url: 'photobookkenya.com',
      },
      {
        cca2: 'LY',
        name: 'Libya',
        url: 'photobooklibya.com',
      },
      {
        cca2: 'ET',
        name: 'Ethiopia',
        url: 'photobookethiopia.com',
      },
      {
        cca2: 'GH',
        name: 'Ghana',
        url: 'photobookghana.com',
      },
      {
        cca2: 'ML',
        name: 'Mali',
        url: 'photobookmali.com',
      },
      {
        cca2: 'MA',
        name: 'Morocco',
        url: 'photobookmorocco.com',
      },
      {
        cca2: 'NG',
        name: 'Nigeria',
        url: 'photobooknigeria.com',
      },
      {
        cca2: 'ZA',
        name: 'South Africa',
        url: 'photobookafrica.com',
      },
      {
        cca2: 'TZ',
        name: 'Tanzania',
        url: 'photobooktanzania.com',
      },
      {
        cca2: 'TN',
        name: 'Tunisia',
        url: 'photobooktunisia.com',
      },
    ],
  },
  {
    regionName: 'Asia Pacific',
    countries: [
      {
        cca2: 'MY',
        name: 'Malaysia',
        url: 'photobook.com.my',
      },
      {
        cca2: 'ID',
        name: 'Indonesia',
        url: 'photobookindonesia.com',
      },
      {
        cca2: 'CN',
        name: 'China',
        url: 'photobookchina.com',
      },
      {
        cca2: 'NP',
        name: 'Nepal',
        url: 'photobooknepal.com',
      },
      {
        cca2: 'IN',
        name: 'India',
        url: 'photobookindia.com',
      },
      {
        cca2: 'MV',
        name: 'Maldives',
        url: 'photobookmaldives.com',
      },
      {
        cca2: 'SG',
        name: 'Singapore',
        url: 'photobook.sg',
      },
      {
        cca2: 'MO',
        name: 'Macau',
        url: 'photobookmacau.com',
      },
      {
        cca2: 'BD',
        name: 'Bangladesh',
        url: 'photobookbangladesh.com',
      },
      {
        cca2: 'LK',
        name: 'Sri Lanka',
        url: 'photobooksrilanka.com',
      },
      {
        cca2: 'TR',
        name: 'Turkey',
        url: 'photobookturkey.com',
      },
      {
        cca2: 'PK',
        name: 'Pakistan',
        url: 'photobookpakistan.com',
      },
      {
        cca2: 'BN',
        name: 'Brunei',
        url: 'photobookbrunei.com',
      },
      {
        cca2: 'PH',
        name: 'Philippines',
        url: 'photobook.com.ph',
      },
      {
        cca2: 'KR',
        name: 'Korea',
        url: 'photobookkorea.com',
      },
      {
        cca2: 'VN',
        name: 'Vietnam',
        url: 'photobookvietnam.com',
      },
      {
        cca2: 'RU',
        name: 'Russian Federation',
        url: 'photobookrussianfederation.com',
      },
      {
        cca2: 'AU',
        name: 'Australia',
        url: 'photobookaustralia.com',
      },
      {
        cca2: 'HK',
        name: 'Hong Kong',
        url: 'photobookhongkong.com',
      },
      {
        cca2: 'TW',
        name: 'Taiwan',
        url: 'photobooktaiwan.com',
      },
      {
        cca2: 'MN',
        name: 'Mongolia',
        url: 'photobookmongolia.com',
      },
      {
        cca2: 'JP',
        name: 'Japan',
        url: 'photobookjapan.com',
      },
      {
        cca2: 'TH',
        name: 'Thailand',
        url: 'photobook.co.th',
      },
      {
        cca2: 'NZ',
        name: 'New Zealand',
        url: 'photobooknewzealand.com',
      },
    ],
  },
  {
    regionName: 'Europe',
    countries: [
      {
        cca2: 'BE',
        name: 'Belgium',
        url: 'photobookbelgium.com',
      },
      {
        cca2: 'DK',
        name: 'Denmark',
        url: 'photobookdenmark.com',
      },
      {
        cca2: 'FR',
        name: 'France',
        url: 'photobookeurope.com',
      },
      {
        cca2: 'DE',
        name: 'Germany',
        url: 'fotobuchdeutschland.com',
      },
      {
        cca2: 'IE',
        name: 'Ireland',
        url: 'photobookireland.com',
      },
      {
        cca2: 'IT',
        name: 'Italy',
        url: 'photobookitaly.com',
      },
      {
        cca2: 'LU',
        name: 'Luxembourg',
        url: 'photobookluxembourg.com',
      },
      {
        cca2: 'NL',
        name: 'Netherlands',
        url: 'photobookeurope.com',
      },
      {
        cca2: 'PT',
        name: 'Portugal',
        url: 'photobookportugal.com',
      },
      {
        cca2: 'ES',
        name: 'Spain',
        url: 'photobookspain.com',
      },
      {
        cca2: 'UK',
        name: 'United Kingdom',
        url: 'photobookuk.co.uk',
      },
      {
        cca2: 'AT',
        name: 'Austria',
        url: 'photobookaustria.com',
      },
      {
        cca2: 'BY',
        name: 'Belarus',
        url: 'photobookbelarus.com',
      },
      {
        cca2: 'BG',
        name: 'Bulgaria',
        url: 'photobookbulgaria.com',
      },
      {
        cca2: 'HR',
        name: 'Croatia',
        url: 'photobookcroatia.com',
      },
      {
        cca2: 'CY',
        name: 'Cyprus',
        url: 'photobookcyprus.com',
      },
      {
        cca2: 'CZ',
        name: 'Czech Republic',
        url: 'photobookczechrepublic.com',
      },
      {
        cca2: 'EE',
        name: 'Estonia',
        url: 'photobookestonia.com',
      },
      {
        cca2: 'GE',
        name: 'Georgia',
        url: 'photobookgeorgia.com',
      },
      {
        cca2: 'GR',
        name: 'Greece',
        url: 'photobookgreece.com',
      },
      {
        cca2: 'HU',
        name: 'Hungary',
        url: 'photobookhungary.com',
      },
      {
        cca2: 'IS',
        name: 'Iceland',
        url: 'photobookiceland.com',
      },

      {
        cca2: 'PL',
        name: 'Poland',
        url: 'photobookpoland.com',
      },
      {
        cca2: 'RO',
        name: 'Romania',
        url: 'photobookromania.com',
      },
      {
        cca2: 'SK',
        name: 'Slovakia',
        url: 'photobookslovakia.com',
      },

      {
        cca2: 'SI',
        name: 'Slovenia',
        url: 'photobookslovenia.com',
      },
      {
        cca2: 'UA',
        name: 'Ukraine',
        url: 'photobookukraine.com',
      },
      {
        cca2: 'EU',
        name: 'Europe',
        url: 'photobookeurope.com',
      },
    ],
  },
  {
    regionName: 'North & South America',
    countries: [
      {
        cca2: 'US',
        name: 'USA',
        url: 'photobookamerica.com',
      },
      {
        cca2: 'CA',
        name: 'Canada',
        url: 'photobookcanada.com',
      },
      {
        cca2: 'AR',
        name: 'Argentina',
        url: 'photobookargentina.com',
      },
      {
        cca2: 'BS',
        name: 'Bahamas',
        url: 'photobookbahamas.com',
      },
      {
        cca2: 'BB',
        name: 'Barbados',
        url: 'photobookbarbados.com',
      },
      {
        cca2: 'CR',
        name: 'Costa Rica',
        url: 'photobookcostarica.com',
      },
      {
        cca2: 'DO',
        name: 'Dominican Republic',
        url: 'photobookdominicanrepublic.com',
      },
      {
        cca2: 'GT',
        name: 'Guatemala',
        url: 'photobookguatemala.com',
      },
      {
        cca2: 'GY',
        name: 'Guyana (British)',
        url: 'photobookguyana.com',
      },
      {
        cca2: 'JM',
        name: 'Jamaica',
        url: 'photobookjamaica.com',
      },
      {
        cca2: 'MX',
        name: 'Mexico',
        url: 'photobookmexico.com',
      },
      {
        cca2: 'PA',
        name: 'Panama',
        url: 'photobookpanama.com',
      },
      {
        cca2: 'BO',
        name: 'Bolivia',
        url: 'photobookbolivia.com',
      },
      {
        cca2: 'BR',
        name: 'Brazil',
        url: 'photobookbrazil.com',
      },
      {
        cca2: 'CL',
        name: 'Chile',
        url: 'photobookchile.com',
      },
      {
        cca2: 'CO',
        name: 'Colombia',
        url: 'photobookcolombia.com',
      },
      {
        cca2: 'EC',
        name: 'Ecuador',
        url: 'photobookecuador.com',
      },
      {
        cca2: 'PY',
        name: 'Paraguay',
        url: 'photobookparaguay.com',
      },
      {
        cca2: 'PE',
        name: 'Peru',
        url: 'photobookperu.com',
      },
      {
        cca2: 'UY',
        name: 'Uruguay',
        url: 'photobookuruguay.com',
      },
      {
        cca2: 'VE',
        name: 'Venezuela',
        url: 'photobookvenezuela.com',
      },
    ],
  },
  {
    regionName: 'Middle East',
    countries: [
      {
        cca2: 'EG',
        name: 'Egypt',
        url: 'photobookegypt.com',
      },
      {
        cca2: 'JO',
        name: 'Jordan',
        url: 'photobookjordan.com',
      },
      {
        cca2: 'OM',
        name: 'Oman',
        url: 'photobookoman.com',
      },
      {
        cca2: 'QA',
        name: 'Qatar',
        url: 'photobookqatar.com',
      },
      {
        cca2: 'SA',
        name: 'Saudi Arabia',
        url: 'photobooksaudiarabia.com',
      },
      {
        cca2: 'AE',
        name: 'Emirates',
        url: 'photobookemirates.com',
      },
      {
        cca2: 'IQ',
        name: 'Iraq',
        url: 'photobookiraq.com',
      },
    ],
  },
];

export default regionsAndCountries;



// WEBPACK FOOTER //
// ./src/Nav/Resources/RegionsAndCountries.js